exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@-webkit-keyframes fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}.fade-in{-webkit-animation:fade-in 2s;-moz-animation:fade-in 2s;-o-animation:fade-in 2s;-ms-animation:fade-in 2s}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/react-spinkit/css/fade-in.css
 ** module id = 202
 ** module chunks = 0
 **/